import { useEffect } from 'react';
import { Fragment } from 'react';

type Props = {
  registrations: number;
  onTick: () => void;
};

const CAP = 5000;

export function RegistrationTicker({ registrations, onTick }: Props): JSX.Element {
  const pct = Math.min(100, (registrations / CAP) * 100);

  useEffect(() => {
    const id = setInterval(() => {
      if (Math.random() < 0.4) onTick();
    }, 2200);
    return () => clearInterval(id);
  }, [onTick]);

  return (
    <section className="overflow-hidden border-t-2 border-b-2 border-ink bg-duck">
      <div
        className="flex items-center gap-16 whitespace-nowrap py-3.5 font-display text-[22px] font-extrabold text-ink"
        style={{ animation: 'marquee 40s linear infinite' }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <Fragment key={i}>
            <span>🦆 {registrations.toLocaleString()} REGISTERED</span>
            <span>·</span>
            <span>{CAP.toLocaleString()} SEATS IN THE TUB</span>
            <span>·</span>
            <span>{pct.toFixed(1)}% FULL</span>
            <span>·</span>
            <span>BYO RUBBER DUCK</span>
            <span>·</span>
            <span>FREE TO ATTEND, EXPENSIVE TO IGNORE</span>
            <span>·</span>
          </Fragment>
        ))}
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </section>
  );
}
